import { useMetadataUser } from 'contexts/metadata-user-context'
import { FC, SelectHTMLAttributes, useEffect, useRef, useState } from 'react'
import { GoPersonAdd } from 'react-icons/go'
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io'
import { ModalUploadFile } from 'shared/ModalUploadFile/ModalUploadFile'

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  optionsList: { value: string; label: string }[]
  setManualModal: (value: boolean) => void
}

export const SelectAddEmployees: FC<SelectProps> = ({
  optionsList,
  setManualModal,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { profile } = useMetadataUser()

  const handleOptionClickAddEmployee = (label?: string) => {
    setIsOpen(false)
    label === 'Manual' ? setManualModal(true) : setIsModalOpen(true)
  }

  useEffect(() => {
    function handleClickOutsideAddEmployee(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutsideAddEmployee)

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideAddEmployee)
    }
  }, [])

  return (
    <div className="flex items-center w-[15rem] gap-4">
      <div className="relative w-full" ref={dropdownRef}>
        <button
          type="button"
          className="
              w-full h-12 bg-[#4F46E5] rounded-full
              px-4 flex items-center justify-between cursor-pointer
            "
          onClick={() => setIsOpen(!isOpen)}
        >
          <GoPersonAdd className="w-7 h-7 text-white" />
          <p className="text-white text-sm">Adicionar Colaborador</p>
          {isOpen ? (
            <IoIosArrowDown className="w-4 h-4 fill-current text-white ml-2" />
          ) : (
            <IoIosArrowForward className="w-4 h-4 fill-current text-white ml-2" />
          )}
        </button>
        {isOpen && (
          <div
            className="
                absolute z-10 mt-2 w-full bg-white dark:bg-neutral-900
                shadow-lg rounded-2xl border-[0.05rem] border-neutral-200/70
                overflow-hidden dark:border-neutral-700
              "
          >
            {optionsList.map((option) => (
              <button
                type="button"
                key={option.value}
                className="
                    px-4 py-2 w-full cursor-pointer text-left hover:bg-[#4F46E5]/90
                    bg-[#4F46E5] dark:hover:bg-[#4F46E5]/80 dark:bg-[#4F46E5]
                    text-white flex items-center
                  "
                onClick={() => handleOptionClickAddEmployee(option.value)}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
        {isModalOpen && (
          <ModalUploadFile
            setModalOpen={setIsModalOpen}
            title={'Cadastro em lote de Colaboradores'}
            profile={profile}
          />
        )}
      </div>
    </div>
  )
}
